<!-- List screen (DiaryList.js) -->
<div class="pdi-wrap" *ngIf="!selectedItem">
  <div class="pdi-tabs">
    <button type="button" class="pdi-tab" [class.active]="activeTab === 'past'" (click)="setTab('past')">{{ 'past' | translate }}</button>
    <button type="button" class="pdi-tab" [class.active]="activeTab === 'today'" (click)="setTab('today')">{{ 'today' | translate }}</button>
    <button type="button" class="pdi-tab" [class.active]="activeTab === 'upcoming'" (click)="setTab('upcoming')">{{ 'upcoming' | translate }}</button>
  </div>

  <div class="pdi-filter-row" *ngIf="subjects.length">
    <select class="pdi-subject-select" [ngModel]="selectedSubjectId" (ngModelChange)="setSubjectFilter($event)">
      <option [ngValue]="null">{{ 'allSubjects' | translate }}</option>
      <option *ngFor="let s of subjects" [ngValue]="s.subjectId">{{ s.subject }}</option>
    </select>
  </div>

  <div class="pdi-list" *ngIf="!listLoading; else pdiLoading">
    <div class="pdi-empty" *ngIf="!items.length && !listError">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>
    <div class="pdi-error" *ngIf="listError">{{ listError }}</div>

    <div class="pdi-row" [class.pdi-row-done]="item.isHomeworkDone" *ngFor="let item of items; trackBy: trackByDiaryId" (click)="openDetail(item)">
      <div class="pdi-row-accent"></div>
      <div class="pdi-row-body">
        <div class="pdi-row-top">
          <span class="pdi-subject-chip">{{ item.subject }}</span>
          <span class="pdi-row-due"><i class="ri-calendar-line"></i> {{ item.dueDate | date: 'dd MMM' }}</span>
        </div>

        <div class="pdi-row-title">
          {{ item.diaryTitle }}
          <i class="ri-attachment-2 pdi-row-attachment" *ngIf="item.isAttachmentWithDiary"></i>
        </div>

        <div class="pdi-row-footer">
          <div class="pdi-row-staff">
            <img *ngIf="item.staffImage" [src]="item.staffImage" class="pdi-staff-photo" alt="" />
            <span *ngIf="!item.staffImage" class="pdi-staff-photo pdi-staff-initial">{{ item.staffName?.charAt(0) }}</span>
            <span>{{ item.staffName }}</span>
          </div>

          <button type="button" class="pdi-tick" [class.pdi-tick-done]="item.isHomeworkDone"
            [disabled]="!!item.isHomeworkDone || markingDoneId === item.diaryId"
            (click)="requestMarkDone(item, $event)">
            <i class="ri-check-line"></i>
            <span>{{ (item.isHomeworkDone ? 'markedDone' : 'markDone') | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template #pdiLoading>
    <div class="pdi-list">
      <div class="pdi-row pdi-row-skeleton" *ngFor="let n of [1,2,3,4]"></div>
    </div>
  </ng-template>

  <div class="pdi-pagination" *ngIf="!listLoading && items.length && maxPageNumber > 1">
    <button type="button" class="pdi-page-btn" [disabled]="currentPage <= 1" (click)="goToPrevPage()">
      <i class="ri-arrow-left-s-line"></i> {{ 'previous' | translate }}
    </button>
    <span class="pdi-page-indicator">{{ currentPage }} / {{ maxPageNumber }}</span>
    <button type="button" class="pdi-page-btn" [disabled]="currentPage >= maxPageNumber" (click)="goToNextPage()">
      {{ 'next' | translate }} <i class="ri-arrow-right-s-line"></i>
    </button>
  </div>
</div>

<!-- Detail screen (DiaryDetailedView.js) — replaces the list entirely
     rather than a popup, same navigation pattern as the mobile screen it
     mirrors: back button returns to the list, header shows subject +
     student name, and the same tick button/pattern as the list row. -->
<div class="pdi-detail-wrap" *ngIf="selectedItem as item">
  <header class="pdi-detail-header">
    <button type="button" class="pdi-detail-back" (click)="closeDetail()"><i class="ri-arrow-left-line"></i></button>
    <div class="pdi-detail-header-text">
      <div class="pdi-detail-header-subject">{{ item.subject }}</div>
      <div class="pdi-detail-header-student">{{ studentName }}</div>
    </div>
    <button type="button" class="pdi-tick" [class.pdi-tick-done]="item.isHomeworkDone"
      [disabled]="!!item.isHomeworkDone || markingDoneId === item.diaryId"
      (click)="requestMarkDone(item, $event)">
      <i class="ri-check-line"></i>
    </button>
  </header>

  <div class="pdi-detail-loading" *ngIf="detailLoading">
    <i class="ri-loader-4-line pdi-spin"></i>
  </div>

  <div class="pdi-detail-error" *ngIf="detailError">{{ detailError }}</div>

  <ng-container *ngIf="detail as d">
    <div class="pdi-detail-card" *ngFor="let entry of d.diaryDetails">
      <h3 class="pdi-detail-title">{{ entry.diaryTitle }}</h3>
      <p class="pdi-detail-description" [innerHTML]="linkify(entry.diaryDescription)"></p>
      <div class="pdi-detail-facts">
        <span *ngIf="entry.diaryDuration">{{ 'duration' | translate }}: {{ entry.diaryDuration }} {{ 'min' | translate }}</span>
        <span *ngIf="entry.submissionDate">{{ 'submissionDate' | translate }}: {{ entry.submissionDate | date: 'dd MMM, y' }}</span>
      </div>
    </div>

    <div class="pdi-detail-card" *ngIf="detailImages.length || detailDocuments.length">
      <h4 class="pdi-attachments-title">{{ 'attachments' | translate }}</h4>

      <div class="pdi-detail-images" *ngIf="detailImages.length">
        <button type="button" *ngFor="let img of detailImages; let i = index" class="pdi-detail-image-tile" (click)="openImageViewer(i)">
          <img [src]="img.DiaryMediaBlurUrl || img.DiaryMediaUrl" alt="" />
        </button>
      </div>

      <div class="pdi-detail-documents" *ngIf="detailDocuments.length">
        <button type="button" *ngFor="let doc of detailDocuments" class="pdi-detail-doc-tile" (click)="openPdfViewer(doc.DiaryMediaUrl)">
          <i class="ri-file-pdf-2-line"></i> {{ 'viewAttachment' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>

<!-- In-app image viewer — a small centered window, not a full-screen takeover -->
<div class="pdi-viewer-overlay" *ngIf="imageViewerIndex !== null" (click)="closeImageViewer()">
  <div class="pdi-image-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="pdi-viewer-close" (click)="closeImageViewer()"><i class="ri-close-line"></i></button>
    <button type="button" class="pdi-viewer-nav pdi-viewer-prev" *ngIf="detailImages.length > 1" (click)="showPrevImage()">
      <i class="ri-arrow-left-s-line"></i>
    </button>
    <img *ngIf="currentViewerImageUrl" [src]="currentViewerImageUrl" class="pdi-image-viewer-img" alt="" />
    <button type="button" class="pdi-viewer-nav pdi-viewer-next" *ngIf="detailImages.length > 1" (click)="showNextImage()">
      <i class="ri-arrow-right-s-line"></i>
    </button>
    <div class="pdi-viewer-counter" *ngIf="detailImages.length > 1">{{ (imageViewerIndex || 0) + 1 }} / {{ detailImages.length }}</div>
  </div>
</div>

<!-- In-app PDF viewer — same small-window treatment -->
<div class="pdi-viewer-overlay" *ngIf="pdfViewerUrl" (click)="closePdfViewer()">
  <div class="pdi-pdf-viewer-window" (click)="$event.stopPropagation()">
    <div class="pdi-pdf-viewer-header">
      <button type="button" class="pdi-viewer-close pdi-viewer-close-light" (click)="closePdfViewer()"><i class="ri-close-line"></i></button>
      <a class="pdi-pdf-download-btn" [href]="pdfViewerDownloadUrl" target="_blank" rel="noopener" download>
        <i class="ri-download-2-line"></i> {{ 'download' | translate }}
      </a>
    </div>
    <iframe [src]="pdfViewerUrl" class="pdi-pdf-viewer-frame"></iframe>
  </div>
</div>

<!-- Mark-done confirmation -->
<div class="pdi-modal-overlay" *ngIf="confirmMarkDoneItem" (click)="cancelMarkDone()">
  <div class="pdi-modal" (click)="$event.stopPropagation()">
    <h3 class="pdi-modal-title">{{ 'markHomeworkDone' | translate }}</h3>
    <p class="pdi-modal-text">{{ 'markHomeworkDoneConfirm' | translate }}</p>
    <div class="pdi-modal-actions">
      <button type="button" class="pdi-modal-btn pdi-modal-btn-secondary" (click)="cancelMarkDone()">{{ 'cancel' | translate }}</button>
      <button type="button" class="pdi-modal-btn pdi-modal-btn-primary" (click)="confirmMarkDone()">{{ 'confirm' | translate }}</button>
    </div>
  </div>
</div>
